import { blockedOrdersSearchSchema } from '@/hooks/queries/credit/useBlockedOrders'
import { createFileRoute } from '@tanstack/react-router'
import { BlockedOrdersCockpitPage } from '../-components/BlockedOrdersCockpitPage'

export const Route = createFileRoute('/_auth/_modules/credit/blocked-orders/pending/')({
  component: RouteComponent,
  validateSearch: (search) => blockedOrdersSearchSchema.parse(search),
})

/** What still needs doing: the orders awaiting review or approval, by payer or one per order. */
function RouteComponent() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  return <BlockedOrdersCockpitPage kind="pending" search={search} navigate={navigate} />
}
